"use client";
import { Heading, Text, Flex } from "@chakra-ui/react";
import { PostMeta } from "@ui/post/article-card/meta";
import { SectionTemplate } from "components/individuals/blocks";
import NextLink from "next/link";
import { Link } from "@chakra-ui/react";

export interface ArticleSectionProps {
  bg: string;
  titleColor: string;
  subtitleColor: string;
  color: string;
  title: string;
  subtitle: string;
  /**
   * A Knowledge Center post displayed in the section
   */
  post: {
    slug: string;
    title: string;
    excerpt: string;
    /**
     * The Knowledge Center category page that this post is under
     */
    aggregatePostPage: {
      slug: string;
      title: string;
    };
  };
}

export const ArticleSection = (props: ArticleSectionProps) => {
  return (
    <SectionTemplate bg={props.bg} borderRadius={0}>
      <Heading as={"h3"} color={props.titleColor}>
        {props?.title}
      </Heading>
      <Text color={props.subtitleColor}>{props?.subtitle}</Text>
      <Flex
        mt={{
          base: 12,
          lg: 16,
        }}
        flexDir={"column"}
        _hover={{
          transform: "scale(1.03)",
          transition: "transform 0.3s ease-in-out",
        }}
        p={8}
        rounded={"lg"}
        shadow={"lg"}
      >
        <PostMeta
          type={props?.post?.aggregatePostPage?.title}
          url={`/knowledge-center/category/${props?.post?.aggregatePostPage?.slug}`}
        />

        <Link
          as={NextLink}
          href={`/knowledge-center/${props?.post?.aggregatePostPage?.slug}/${props?.post?.slug}`}
          _hover={{
            textDecoration: "none",
            textTransform: "none",
          }}
        >
          <Heading
            as="h3"
            mt={{
              base: 4,
              lg: 6,
            }}
            color={props.color}
            textDecor={"none"}
          >
            {props?.post?.title}
          </Heading>
        </Link>
        <Link
          as={NextLink}
          href={`/knowledge-center/${props?.post?.aggregatePostPage?.slug}/${props?.post?.slug}`}
          _hover={{
            textDecoration: "none",
            textTransform: "none",
          }}
        >
          <Text
            mt={{
              base: 4,
              lg: 6,
            }}
            color={props.color}
          >
            {props?.post?.excerpt}
          </Text>
        </Link>
      </Flex>
    </SectionTemplate>
  );
};
